import FrontpageHero from './frontpageHero'

export default FrontpageHero
